import React, {FC} from 'react';
import styled from 'styled-components';

import {Trans} from '../../../../../../libs/shared/core/src/helpers/internationalization/react';
import {CommentUnfurlTypesEnum} from '../../../../../models/api/commentUnfurlModel';
import {ConversationModel} from '../../../../../models/api/conversationModel';
import {TopicModel} from '../../../../../models/api/topicModel';
import {ConversationSummaryTopicReferencePreviewerUnfurlContainer} from '../../activity/comment/unfurl/referencePreviewer/topicReferencePreviewerUnfurlContainer';
import {StyledEmptyDiv} from './conversationSummaryCommonStyles';
import {ConversationSummarySectionsEnum} from './conversationSummarySections';

/*
 * Props.
 */

interface ConversationSummaryReferencePreviewersProps {
  conversation: ConversationModel;
  topics: ReadonlyArray<TopicModel>;
  selectedTopicId?: number;
}

/*
 * Style.
 */

const StyledCommentUnfurlsWrapperDiv = styled.div`
  display: flex;
  flex-flow: column;
  gap: 8px;
`;

const StyledConversationSummaryTopicReferencePreviewerUnfurlContainerDiv = styled.div`
  margin: auto;
  width: fit-content;
  border: 1px solid ${(p) => p.theme.greys.shade20};
  border-radius: 6px;
  background: ${(p) => p.theme.greys.white};

  &:first-child {
    margin-top: 8px;
  }
`;

const StyledNoReferencePreviewersDiv = styled(StyledEmptyDiv)`
  padding-left: 4px;
  margin-top: 4px;
`;

/*
 * Component.
 */

export const ConversationSummaryReferencePreviewers: FC<ConversationSummaryReferencePreviewersProps> = (
  props,
) => {
  const {topics} = props;

  if (topics.length === 0) {
    return (
      <StyledNoReferencePreviewersDiv data-testid={ConversationSummarySectionsEnum.REFERENCE_PREVIEWERS}>
        <Trans id="conversation-summary-reference-previewers-empty">None</Trans>
      </StyledNoReferencePreviewersDiv>
    );
  }
  return (
    <StyledCommentUnfurlsWrapperDiv data-testid={ConversationSummarySectionsEnum.REFERENCE_PREVIEWERS}>
      {topics.map((topic) => (
        <StyledConversationSummaryTopicReferencePreviewerUnfurlContainerDiv>
          <ConversationSummaryTopicReferencePreviewerUnfurlContainer
            key={topic.id}
            unfurl={{
              type: CommentUnfurlTypesEnum.TOPIC,
              topic,
              token: topic.alias,
            }}
          />
        </StyledConversationSummaryTopicReferencePreviewerUnfurlContainerDiv>
      ))}
    </StyledCommentUnfurlsWrapperDiv>
  );
};
